import { Route, Redirect } from 'react-router-dom'
import { store } from '../../store'

const PrivateRoute = ({children, ...rest}) => {
  const state = store.getState()
  return (
    <Route {...rest}>{state.user.token ? children: <Redirect to='/login' />}</Route>
  )
}

export default PrivateRoute
